<template>
  <header
    class="descriptor-header"
    tabindex="0"
    role="button"
    aria-label="Return to main page"
    @click="returnToMainPage"
    @keydown.enter="returnToMainPage"
    @keydown.space.prevent="returnToMainPage"
  >
    <div class="logo-container">
      <img :src="LogoImage" alt="Logo" class="logo-image" />
      {{ logo }}
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useCapitalizedDescriptor } from '@/composables/useCapitalizedDescriptor'

import LogoImage from '../assets/logo.svg'

type Emits = {
  (event: 'returnToMainPage'): void
}
const emit = defineEmits<Emits>()

const descriptor = useCapitalizedDescriptor()
const logo = computed(() => descriptor.value.toLowerCase())

function returnToMainPage(): void {
  emit('returnToMainPage')
}
</script>

<style scoped lang="scss">
.descriptor-header {
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  left: 0;
  padding: 20px 80px;
  cursor: pointer;
  text-align: start;
  color: #333;
  border-bottom: 1px solid #ebebeb;
  background: #fff;
  font-size: 24px;
  font-weight: 600;
  line-height: 40px;

  .logo-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  }

  .logo-image{
    width: 60px;
    height: 40px;
    margin-right: 16px;
  }
}

@media (max-width: 920px) {
  .descriptor-header {
    padding: 20px 16px;
    font-size: 20px;
    line-height: 26px;
  }
}
</style>
